import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../config/FirebaseConfig";
import { getDocDataById } from "../models/DataFunctions";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Define initial state
  const saved_data = {
    folders: [],
    events: [],
  };

  const initialState = {
    user: null,
    theme: "light",
    dev: false,
    dev_url: "http://127.0.0.1:8000/",
    prod_url: process.env.REACT_APP_API_URL,
    dev_ws: "http://127.0.0.1:8081/",
    prod_ws: process.env.REACT_APP_WS_URL,
    folders_config: null,
    invoices_config: null,
    login_security: null,
    planning_config: null,
    saved_data: saved_data,
    promotions: {},
    original_admin: null,
  };

  // Load the initial state from localStorage or set default values
  const [appState, setAppState] = useState(() => {
    const savedState = localStorage.getItem("appState");
    return savedState ? JSON.parse(savedState) : initialState;
  });

  // Save appState to localStorage whenever it changes
  useEffect(() => {
    const { saved_data, ...stateToSave } = appState;
    localStorage.setItem("appState", JSON.stringify(stateToSave));
  }, [appState]);

  const [filter, setFilterReal] = useState({
    org_id: null,
    type: null,
    workspace: null,
    state: null,
  });

  const [eventFilter, setEventFilter] = useState({
    org_id: null,
    type: null,
    workspace: null,
  });

  const [isLoadingFolders, setIsLoadingFolders] = useState(false);
  const [isLoadingEvents, setIsLoadingEvents] = useState(false);

  // Function to update the prod_url in appState
  const updateProdUrl = (newUrl) => {
    setAppState((prevState) => ({
      ...prevState,
      prod_url: newUrl,
    }));
  };

  const setFilter = (data) => {
    setAppState((prevState) => ({
      ...prevState,
      saved_data: {
        ...prevState.saved_data,
        folders: null,
        events: null,
      },
    }));
    setFilterReal(data);
  };

  // Fetch events function
  const fetchEvents = async () => {};

  // Fetch events when eventFilter changes
  useEffect(() => {
    fetchEvents();
  }, [eventFilter]);

  const refreshEvents = () => {
    fetchEvents();
  };

  const refreshAll = () => {
    fetchEvents();
  };

  const resetAppStateLogin = async () => {
    setFilter({
      org_id: null,
      type: null,
      workspace: null,
      state: "current",
    });
    setEventFilter({
      org_id: null,
      type: null,
      workspace: null,
    });
    setAppState((prevState) => ({
      ...prevState,
      folders: null,
      events: null,
      folders_config: {},
      invoices_config: {},
    }));
  };

  const setOriginalAdmin = (adminData) => {
    setAppState((prevState) => ({
      ...prevState,
      original_admin: adminData,
    }));
  };

  const clearOriginalAdmin = () => {
    setAppState((prevState) => ({
      ...prevState,
      original_admin: null,
    }));
  };

  // Reset function to restore appState to initial values
  const resetAppState = () => {
    setAppState(initialState);
  };

  const fetchFolders = async () => {};
  const refreshFolders = async () => {};

  return (
    <AppContext.Provider
      value={{
        appState,
        setAppState,
        updateProdUrl,
        resetAppState,
        setFilter,
        filter,
        setEventFilter,
        resetAppStateLogin,
        fetchFolders,
        fetchEvents,
        refreshFolders,
        refreshEvents,
        refreshAll,
        isLoadingFolders,
        isLoadingEvents,
        setOriginalAdmin,
        clearOriginalAdmin,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
